import { Formik } from 'formik';
import { Link, useSearchParams } from 'react-router-dom';

import AuthContainer from './AuthContainer';
import AuthForm from './AuthForm';
import AuthInput from './AuthInput';
import AuthOr from './AuthOr';
import AuthSub from './AuthSub';
import AuthSubmit from './AuthSubmit';
import AuthTitle from './AuthTitle';
import { confirmInviteSchema } from './schemas/confirm-invite-schema';

import { AuthRoutes } from '@/interfaces/auth/AuthRoutes.enum';

type PropTypes = {
	handleSubmit: (email: string, otp: string, password: string) => Promise<void>;
	loading: boolean;
};

export default function ConfirmInviteForm({
	handleSubmit,
	loading,
}: PropTypes) {
	const [searchParams] = useSearchParams();
	const invitedEmail = searchParams.get('email') || '';

	const initialValues = {
		email: invitedEmail,
		otp: '',
		password: '',
	};

	return (
		<AuthContainer>
			<Formik
				initialValues={initialValues}
				validationSchema={confirmInviteSchema}
				onSubmit={({ email, otp, password }) =>
					handleSubmit(email, otp, password)
				}
				enableReinitialize
			>
				{({ errors, touched }) => (
					<AuthForm>
						<AuthTitle>Confirm Invite</AuthTitle>

						<AuthInput
							name="email"
							label="Email"
							type="email"
							disabled
							placeholder="user@example.com"
							error={!!errors.email}
							touched={touched.email}
						/>

						<AuthInput
							name="otp"
							label="OTP Code"
							type="tel"
							placeholder="123456"
							error={!!errors.otp}
							touched={touched.otp}
						/>

						<AuthInput
							name="password"
							label="Password"
							type="password"
							placeholder="********"
							error={!!errors.password}
							touched={touched.password}
						/>

						<AuthSubmit
							isLoading={loading}
							className="bg-purpleBrand-500 hover:bg-purpleBrand-600 rounded-md active:bg-purpleBrand-900"
						/>

						<AuthOr />

						<AuthSub>
							<p>
								Didn't receive your code?{' '}
								<Link
									className="font-medium text-purpleBrand-500"
									to={AuthRoutes.ResendConfirmationCode}
								>
									Click here
								</Link>
							</p>
							<p>
								Already confirmed?{' '}
								<Link
									className="font-medium text-purpleBrand-500"
									to={AuthRoutes.SignIn}
								>
									Sign in
								</Link>
							</p>
						</AuthSub>
					</AuthForm>
				)}
			</Formik>
		</AuthContainer>
	);
}
